export const gdpr = {
  routes: [
    {
      path: "/process-datasource/:department_process",
      component: () => import("../organization-process-datasource-view"),
    },
  ],
};
